import React from 'react';
import { Line } from 'react-chartjs-2';



const options = {
  plugins: {
            legend: {
                display: false
            }
        },
  scales: {
    yAxes: 
      {
        beginAtZero: true,
        type: 'linear', 
        grid:{
            display: false,
               drawBorder: false
        },
        ticks:{
          stepSize: 1,
          display: false
            
        }
      },
      xAxes:{
         ticks:{
                    color: 'black'
                },
        grid:{
            display: false,
        }
      }
  },
};

const MultiAxisLineChart = (props) => {
  const data = {
    labels: props.data.week,
    datasets: [
      {
        data: props.data.data,
        fill: false,
        backgroundColor: 'rgb(54, 162, 235)',
        borderColor: 'rgba(54, 162, 235, 0.2)'
      },
    ],
  };
  return (
  // <>
    
    <Line data={data} options={options} />
  // </>
)}

export default MultiAxisLineChart;